import { View, StyleSheet, Text, Image } from '@react-pdf/renderer';
import React from 'react';

import { PDFKinematicGraphSection } from '@/components/PDFDownload/Components/PDFKinematicGraphSection';
import { PDFPage } from '@/components/PDFDownload/Components/PDFPage';
import { RunAnalysisCards } from '@/components/PDFDownload/Components/PDFRunAnalysis';
import { PDFRunInfoTable } from '@/components/PDFDownload/Components/PDFRunInfoTable';
import { PDFVersion } from '@/components/PDFDownload/PDFDocument';
import { PDFFormatting, PDFTextStyles } from '@/components/PDFDownload/styles';

const styles = StyleSheet.create({
  FootplantChartImage: {
    height: '100%',
    width: 'auto',
  },
});

export interface DocumentProps {
  reportInfo: any;
  data: any;
  version: PDFVersion;
}

export const PDFRunReport = ({ reportInfo, data, version }: DocumentProps) => {
  const reportName = reportInfo.reportName;
  const logoUrl = data.logoURL;
  return (
    <>
      {/* Run Analysis Cards */}
      <PDFPage PageNumber={1} logoUrl={logoUrl} reportName={reportName}>
        <RunAnalysisCards attractorLabels={data.attractorLabels} />
      </PDFPage>

      {/* Footplant & Table */}
      <PDFPage PageNumber={2} logoUrl={logoUrl} reportName={reportName}>
        <View style={PDFFormatting.contentContainer_45H}>
          <View style={PDFFormatting.contenContainer_50w}>
            <Text style={PDFTextStyles.containerTitle}>Projection Footplant - Left</Text>
            {/* Graphs */}
            <Image src={data.footplantAtInitialContact_LeftChartDataUri} style={styles.FootplantChartImage} />
            <Image src={data.footplantAtMidStance_LeftChartDataUri} style={styles.FootplantChartImage} />
            <Image src={data.footplantAtHeelOff_LeftChartDataUri} style={styles.FootplantChartImage} />
          </View>
          <View debug={false} style={PDFFormatting.contenContainer_50w}>
            <Text style={PDFTextStyles.containerTitle}>Projection Footplant - Right</Text>
            {/* Graphs */}
            <Image src={data.footplantAtInitialContact_RightChartDataUri} style={styles.FootplantChartImage} />
            <Image src={data.footplantAtMidStance_RightChartDataUri} style={styles.FootplantChartImage} />
            <Image src={data.footplantAtHeelOff_RightChartDataUri} style={styles.FootplantChartImage} />
          </View>
        </View>
        <View style={PDFFormatting.contentContainer_45H}>
          <View style={PDFFormatting.tableContainer}>
            <Text style={PDFTextStyles.containerTitle}>Info</Text>
            <PDFRunInfoTable romData={data.romData} runningStatusData={data.runningStatusData} />
          </View>
        </View>
      </PDFPage>

      {/* Kinematic Graphs */}
      {version == 'Specialist' && (
        <PDFPage PageNumber={3} logoUrl={logoUrl} reportName={reportName}>
          <PDFKinematicGraphSection
            coronalGraph={data.pelvisKinematicCoronalChartDataUri}
            sagittalGraph={data.pelvisKinematicSagittalChartDataUri}
            title={'Pelvis'}
            transversalGraph={data.pelvisKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.hipKinematicCoronalChartDataUri}
            sagittalGraph={data.hipKinematicSagittalChartDataUri}
            title={'Hip'}
            transversalGraph={data.hipKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.kneeKinematicCoronalChartDataUri}
            sagittalGraph={data.kneeKinematicSagittalChartDataUri}
            title={'Knee'}
            transversalGraph={data.kneeKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.ankleKinematicCoronalChartDataUri}
            sagittalGraph={data.ankleKinematicSagittalChartDataUri}
            title={'Ankle'}
            transversalGraph={data.ankleKinematicTransversalChartDataUri}
          />
        </PDFPage>
      )}
    </>
  );
};
